import React from "react";
import { Stack } from "@mui/material";
import SpecsChargeExtraSizeField from "./SpecsChargeExtraSizeField";
import SpecsJsonField from "./SpecsJsonField";
import SpecsNumberField from "./SpecsNumberField";
import SpecsPricingCurrencyField from "./SpecsPricingCurrencyField";
import { readObject } from "./utils";

export default function SpecsPricingField({
  label,
  value,
  debugPath,
  clickToEdit,
  onChange,
}: {
  label: string;
  value: unknown;
  debugPath?: string;
  clickToEdit?: boolean;
  onChange: (nextValue: unknown) => void;
}) {
  const source = readObject(value);
  const { freeCredits, minQty, pricingCurrency, chargeExtraSize, ...extra } =
    source;

  return (
    <Stack spacing={1.5}>
      <SpecsNumberField
        label={`${label} Free Credits`}
        value={typeof freeCredits === "number" ? freeCredits : null}
        allowNull
        debugPath={debugPath ? `${debugPath}.freeCredits` : undefined}
        clickToEdit={clickToEdit}
        onChange={(nextValue) =>
          onChange({
            ...extra,
            ...(nextValue === null ? {} : { freeCredits: nextValue }),
            ...(typeof minQty === "number" ? { minQty } : {}),
            ...(pricingCurrency ? { pricingCurrency } : {}),
            ...(chargeExtraSize ? { chargeExtraSize } : {}),
          })
        }
      />
      <SpecsNumberField
        label={`${label} Min Qty`}
        value={typeof minQty === "number" ? minQty : null}
        allowNull
        debugPath={debugPath ? `${debugPath}.minQty` : undefined}
        clickToEdit={clickToEdit}
        onChange={(nextValue) =>
          onChange({
            ...extra,
            ...(typeof freeCredits === "number" ? { freeCredits } : {}),
            ...(nextValue === null ? {} : { minQty: nextValue }),
            ...(pricingCurrency ? { pricingCurrency } : {}),
            ...(chargeExtraSize ? { chargeExtraSize } : {}),
          })
        }
      />
      <SpecsPricingCurrencyField
        label={`${label} Pricing Currency`}
        value={pricingCurrency ?? {}}
        debugPath={debugPath ? `${debugPath}.pricingCurrency` : undefined}
        clickToEdit={clickToEdit}
        onChange={(nextPricingCurrency) =>
          onChange({
            ...extra,
            ...(typeof freeCredits === "number" ? { freeCredits } : {}),
            ...(typeof minQty === "number" ? { minQty } : {}),
            pricingCurrency: readObject(nextPricingCurrency),
            ...(chargeExtraSize ? { chargeExtraSize } : {}),
          })
        }
      />
      <SpecsChargeExtraSizeField
        label={`${label} Charge Extra Size`}
        value={Array.isArray(chargeExtraSize) ? chargeExtraSize : []}
        debugPath={debugPath ? `${debugPath}.chargeExtraSize` : undefined}
        clickToEdit={clickToEdit}
        onChange={(nextChargeExtraSize) =>
          onChange({
            ...extra,
            ...(typeof freeCredits === "number" ? { freeCredits } : {}),
            ...(typeof minQty === "number" ? { minQty } : {}),
            ...(pricingCurrency ? { pricingCurrency } : {}),
            chargeExtraSize: Array.isArray(nextChargeExtraSize)
              ? nextChargeExtraSize
              : [],
          })
        }
      />
      <SpecsJsonField
        label={`${label} Extra JSON`}
        value={extra}
        minRows={4}
        debugPath={debugPath}
        clickToEdit={clickToEdit}
        onChange={(nextExtra) =>
          onChange({
            ...readObject(nextExtra),
            ...(typeof freeCredits === "number" ? { freeCredits } : {}),
            ...(typeof minQty === "number" ? { minQty } : {}),
            ...(pricingCurrency ? { pricingCurrency } : {}),
            ...(chargeExtraSize ? { chargeExtraSize } : {}),
          })
        }
      />
    </Stack>
  );
}
